<template>
  <MobileContainer>
    <MobileHeader slot="header">
      {{ title }}
    </MobileHeader>
    <div :class="$style.main">
      <div :class="$style.mainTop">
        <img :class="$style.mainLogo"
             srcset="@/assets/img/LOGO@2x.png, @/assets/img/LOGO.png"
             src="@/assets/img/LOGO.png"
             alt="Burger Boss">

        <p v-show="showWelcomeText"
           :class="$style.welcomeText">Welcome Back!</p>
      </div>
      <div :class="$style.mainBottom">
        <router-view @link-sent="forgotPasswordSuccess()"/>
      </div>
    </div>

    <!-- Forgot password success modal -->
    <MobileModal v-model="showPasswordResetMsg"
                 dialog
                 center-content>
      <MobileConfirmDialog title="Password Reset"
                           confirm-text="OK"
                           cancel-disabled
                           @confirm="goToMain()">
        Please check your email for a link.
      </MobileConfirmDialog>
    </MobileModal>
    <!-- / Forgot password success modal -->
  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import MobileModal from '@/apps/mobile/components/MobileModal';
import MobileConfirmDialog from '@/apps/mobile/components/MobileConfirmDialog';

/**
 * Mobile join or sign in main container.
 */
@Component({
  components: {
    MobileContainer,
    MobileHeader,
    MobileModal,
    MobileConfirmDialog,
  },
})
export default class MobileSignIn extends Vue {
  /**
   * Password reset message.
   * @type {boolean}
   */
  showPasswordResetMsg = false;

  /**
   * Current title.
   * @returns {String} title - current title.
   */
  get title() {
    return this.$route.meta.title;
  }

  /**
   * Welcome text show or hide.
   * @returns {boolean}
   */
  get showWelcomeText() {
    return this.$route.meta.welcomeText;
  }

  /**
   * Forgot password success.
   */
  forgotPasswordSuccess() {
    this.showPasswordResetMsg = true;
  }

  /**
   * Go to main.
   */
  goToMain() {
    this.$router.push({ name: 'join-sign-in' });
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
@import "@/style/helpers.scss";

.main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  padding: 0 $mobile-content-side-padding;

  &Top,
  &Bottom {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 30px;
  }

  &Bottom {
    padding: 0 0 80px 0;
  }
}

.mainLogo {
  height: 169px;
  width: 169px;
  margin: 57px 0 54px 0;
}

.welcomeText {
  color: $black-semi-transparent;
  font-family: $decor-font-family;
  font-size: rem(24px);
  letter-spacing: rem(0.67px);
  text-align: center;
  margin-bottom: 17px;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileSignIn.vue